import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { SearchBidColumn as SearchBidColumnConfig } from '@bingads-webui-campaign/ad-groups-data';
import { BidBaseColumn, commonBidStrategyListToDisableBidAmountEdit } from './bid-base-column';

const appConfig = globalContext.require('component/config/index');
const permissions = appConfig.get('Permissions');

export class SearchBidColumn extends BidBaseColumn {
  constructor({ i18n, view, isForVNext }) {
    super({
      ...SearchBidColumnConfig,
      title: (permissions.IsVideoAdsForCampaignEnabled || permissions.IsManualCpmEnabled)
        ? i18n.getString('ColumnName_CpcBid')
        : i18n.getString('ColumnName_SearchBid'),
      i18n,
      view,
      bidStrategyListToDisableBidAmountEdit: commonBidStrategyListToDisableBidAmountEdit(['EnhancedCpc', 'ManualCpc']),
      isForVNext,
    });
  }
}
